import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const EventTag = ({ className, Icon, text }) => (
  <div className={classnames('flex items-center mb-5 lg:mb-0', className)}>
    <div className="w-6 mr-3 flex items-center">
      <Icon className="w-full" />
    </div>
    <div className="text-white text-sm opacity-50 uppercase">{text}</div>
  </div>
)

EventTag.propTypes = {
  Icon: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
}

export default EventTag
